export enum UserRole {
  SUPPORT = 'SUPPORT',
  EMPLOYER_ADMIN = 'EMPLOYER_ADMIN',
  EMPLOYER_WRITE = 'EMPLOYER_WRITE',
  EMPLOYEE = 'EMPLOYEE',
  MANAGER = 'MANAGER',
}

export enum UserTitle {
  EMPLOYEE_SALARY_ADMIN = 'EMPLOYEE_SALARY_ADMIN',
}

export const ADMIN_ROLES = [
  UserRole.SUPPORT,
  UserRole.EMPLOYER_ADMIN,
  UserRole.EMPLOYER_WRITE,
];
